export default "/imgs/M-PESA-logo-2.png"